$ ->
  return unless $('.swipe-carousel')[0]
  swipe = new Swipe($('.swipe-carousel > div')[0])
  $(".swipe-carousel-nav li:eq(#{swipe.getPos()})").addClass 'is-current'

  $('.swipe-carousel > div').on 'swipeSlide', ->
    $('.swipe-carousel-nav .is-current').removeClass 'is-current'
    $(".swipe-carousel-nav li:eq(#{swipe.getPos()})").addClass 'is-current'

  $('.swipe-carousel-nav li').on 'click', ->
    swipe.slide($(this).index())

  $('.swipe-carousel-prev').on 'click', ->
    swipe.prev()
  $('.swipe-carousel-next').on 'click', ->
    swipe.next()
